<style scoped>
.share-template {
  padding: 0 3px;
}
.share-template span.ivu-radio + * {
  display: inline-block;
}
.share-template .ivu-radio-wrapper {
  margin-right: ;
}
.input-field {
  margin-top: 5px;
}
.action-buttons {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  margin-top: 20px;
  padding-top: 15px;
}
.success-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.hint {
  color: #aaa;
}
.hint-name {
  position: absolute;
  top: 25px;
  left: 0;
  font-size: 11px;
  font-style: italic;
}
</style>
<style>
.hint
  > .tel-input-template
  > .ivu-row
  > .ivu-col
  > .input-default
  > .ivu-input-group-prepend
  > .ivu-dropdown
  > .ivu-select-dropdown {
  top: -205px !important;
}

.group-invite-tabs .ivu-tabs-nav .ivu-tabs-tab-active {
  background: #f0f0f0 !important;
}
.share-template .input-dial-code {
  line-height: 32px;
}
.share-template .ivu-input-group-small .ivu-input,
.share-template .ivu-input-group-small > .ivu-input-group-append,
.share-template .ivu-input-group-small > .ivu-input-group-prepend {
  height: 32px;
}
</style>

<style lang="scss">
.share-placeholder {
  ::-webkit-input-placeholder {
    font-style: italic;
    font-size: 14px;
    font-weight: 700;
  }
  :-moz-placeholder {
    font-style: italic;
    font-size: 14px;
    font-weight: 700;
  }
  ::-moz-placeholder {
    font-style: italic;
    font-size: 14px;
    font-weight: 700;
  }
  :-ms-input-placeholder {
    font-style: italic;
    font-size: 14px;
    font-weight: 700;
  }
}
</style>

<template>
  <div class="share-template">
    <Row type="flex" justify="center">
      <!-- <Col v-if="!showSuccess" :span="24"> -->
      <Col :span="24">
        <Tabs v-if="!isGroupInvite" @on-click="tabChange" class="group-invite-tabs">
          <TabPane name="mobile" label="Phone"></TabPane>
          <TabPane name="email" label="Email"></TabPane>
        </Tabs>
        <div>
          <!-- <p v-if="!isGroupInvite" style="margin-bottom:25px; display: none; ">
            <b style="line-height:24px;margin-right:5px">Hi</b>
            <span style="position:relative">
              <Input
                style="width:200px;vertical-align:bottom"
                size="small"
                class="input-field"
                @on-change="enableShare()"
                v-model="prescription.attach_journal.first_name"
                placeholder="Enter name"
              />
              <span class="hint hint-name"
                >(Ex: Mr. Mascarinas, Jefry, Mom)</span
              >
            </span>
            <span style="line-height:24px;margin-left:3px">,</span>
          </p>-->
          <!-- <p v-if="brandInfo && !isGroupInvite" style="margin-bottom:15px;color:#848484">
            <span v-html="brandInfo.preview_text"></span>
          </p>-->
          <!-- <p v-if="userInfo && !isGroupInvite" align="right" style="margin-bottom:15px">
            <b>{{userInfo.display_name}}</b>
            <Avatar
              :src="userInfo.avatar"
              style="margin-left:5px;width:40px;height:40px;border-radius:100%"
            />
          </p>-->
          <div v-if="setShareType == 'email' && !isGroupInvite" style="margin-top: 10px;">
            <!-- <p class="hint">Email Address</p> -->
            <Input
              class="input-field share-placeholder"
              placeholder="Enter email address"
              @on-change="onEmailInput()"
              v-model="prescription.email"
              type="email"
            />
          </div>
          <p v-else class="hint" style="line-height:27px; margin-top: 15px;">
            <!-- Mobile Number -->
            <tel-input v-model="prescription.mobile_number" @onTelInput="onTelInput" ref="telInput"></tel-input>
          </p>
          <Button
            type="primary"
            long
            size="small"
            style="margin-top:10px"
            @click="sharePrescription()"
            :disabled="!isDisabled"
          >Send</Button>
        </div>

        <div class="share-fields" v-if="false">
          <div style="margin-bottom:25px;text-align:center">
            <img
              alt=" "
              src="@/assets/logo.png"
              style="width:15%;margin-right:10px;vertical-align:middle"
            />
            <span style="margin-top:-5px;font-size:22px;vertical-align:middle">Sharpen Colleges</span>
          </div>
          <Row :gutter="16">
            <Col :span="12">
              <div style="margin-bottom:10px">
                <label>
                  First Name
                  <Input
                    class="input-field"
                    @on-change="enableShare()"
                    v-model="prescription.attach_journal.first_name"
                    placeholder="First name"
                  />
                </label>
              </div>
            </Col>
            <Col :span="12">
              <div style="margin-bottom:15px">
                <label>
                  Last Name
                  <Input
                    class="input-field"
                    @on-change="enableShare()"
                    v-model="prescription.attach_journal.last_name"
                    placeholder="Last name"
                  />
                </label>
              </div>
            </Col>
            <Col :span="12">
              <div style="margin-bottom:15px">
                <label>
                  Mobile
                  <Input
                    class="input-field"
                    @on-change="enableShare()"
                    @on-keyup="setComputedDuration"
                    v-model="prescription.mobile_number"
                    :maxlength="13"
                    placeholder="+639123456789"
                  ></Input>
                </label>
              </div>
            </Col>
          </Row>
          <!-- <Tabs :animated="false">
            <TabPane label="Via Mobile" name="via_mobile">
              <div style="padding:5px;">
                <label>Mobile
                  <Input class="input-field" @on-change="enableShare()" @on-keyup="setComputedDuration"
                  v-model="prescription.mobile_number" :maxlength="13"
                  placeholder="+639123456789"></Input>
                </label>
              </div>
            </TabPane>
            <TabPane label="Via Email" name="via_email">
              <div style="padding:5px;">
                <label>Email
                  <Input class="input-field" @on-change="enableShare()" @on-keyup="clearMobile()"
                  v-model="prescription.email" type="email">
                    <span slot="prepend">@</span>
                  </Input>
                </label>
              </div>
            </TabPane>
          </Tabs>-->
        </div>
        <div class="action-buttons" v-if="false">
          <Button type="primary" @click="sharePrescription()" :disabled="!isDisabled">Share</Button>
        </div>
      </Col>
      <!-- <Col v-else :span="24">
        <div class="success-container">
          <div align="center" style="padding:15px;border-radius:4px">
            <Icon :size="50" color="#4BB543" type="checkmark-circled"></Icon>
          </div>
          <p style="margin-top:5px;font-size:20px">Invitation has been sent</p>
        </div>
      </Col>-->
    </Row>
  </div>
</template>

<script>
import _ from "lodash";
import { TelInput } from "@/helpers/tel-input";
import ModalHolder from "@/components/ModalHolderComponent";
import CountryCodes from "@/assets/country-codes.json";
import Utils from "@/utils";
import { mapGetters } from "vuex";
import { Message } from "iview";

export default {
  name: "ShareComponent",
  props: {
    brandId: {
      type: String,
      default: Cons[0].BRAND_ID
    },
    prescriberId: {
      type: String,
      default: ""
    },
    shareType: {
      type: String,
      default: "email"
    }
  },
  data() {
    return {
      isDisabled: false,
      hasFullName: false,
      isNumValid: false,
      mobile_number: "",
      brandInfo: {},
      setShareType: "mobile"
    };
  },
  mounted() {
    if (!this.isGroupInvite) {
      this.getBrand(this.brandId);
    }
  },
  methods: {
    tabChange(name){
      if(name == 'mobile'){
        this.setShareType = 'mobile'
        this.enableShare();
      }
      if(name == 'email'){
        this.setShareType = 'email'
        this.onEmailInput();
      }
    },
    onTelInput(res) {
      if (res.isValid) {
        this.isNumValid = res.isValid;
        this.prescription.mobile_number = res.number;
        this.enableShare();
      } else {
        this.isNumValid = res.isValid;
        this.enableShare();
      }
    },
    onEmailInput() {
      this.isDisabled = Utils.validateEmail(this.prescription.email);
    },
    enableShare() {
      this.hasFullName = this.prescription.attach_journal.first_name
        ? true
        : false;
      this.isDisabled = this.isNumValid;
      // this.isDisabled = (!(this.hasFullName && (this.prescription.email || this.prescription.mobile_number)));
    },
    // clearEmail() {
    //   this.prescription.email = '';
    //   this.validateNum();
    // },
    // clearMobile() {
    //   this.prescription.mobile_number = '';
    // },
    validateNum() {
      let num = this.prescription.mobile_number,
        reg = new RegExp("[^+?0-9]", "g").exec(num);

      if (!reg && num.length == 13) {
        this.prescription.mobile_number = num;
      } else {
        // this.$Message({
        //   closable: true,
        //   durationInSec:5,
        //   title: { content:'Invalid' },
        //   icon: 'ios-close',
        //   message: { content: 'Invalid mobile number.' },
        //   buttons: [
        //     { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
        //   ]
        // });
      }
    },
    sharePrescription() {
      if (this.isDisabled) {
        if (this.isGroupInvite) {
          let payload = {
            careplan_id: this.groupInviteId,
            group_id: Cons[0].BRAND_ID,
            permission: 1,
            is_accepted: false,
            mobile: this.prescription.mobile_number,
            email: this.prescription.email
          };

          this.$store
            .dispatch("share/shareGroup", payload)
            .then(res => {
              this.showSuccess = true;
              this.$store.commit("share/setShowInvite", false);

              this.$Message({
                closable: true,
                durationInSec: 10,
                title: { content: "Sent" },
                icon: "checkmark",
                message: { content: "Invitation has been sent." },
                buttons: [
                  {
                    label: "Ok",
                    type: "primary",
                    hideAfter: true,
                    action: () => {
                      this.$emit("invitationSent");
                    }
                  }
                ]
              });
            })
            .catch(e => {
              Message.warning(
                e.response.data.error.message || "Unable to send invitation"
              );
            });
        } else {
          this.prescription.group_id = this.brandInfo.id;
          if (this.prescriberId) this.prescription.prescribed_by = this.prescriberId;
          this.$store
            .dispatch("share/sharePrescription", {
              prescription: this.prescription
            })
            .then(res => {
              this.showSuccess = true;
              this.$store.commit("share/setShowInvite", false);
              this.$store.dispatch(
                "points/setUserActionPoints",
                {
                  action: "share_app"
                },
                { root: 1 }
              );
              this.$Message({
                closable: true,
                durationInSec: 10,
                title: { content: "Sent" },
                icon: "checkmark",
                message: { content: "Invitation has been sent." },
                buttons: [
                  {
                    label: "Ok",
                    type: "primary",
                    hideAfter: true,
                    action: () => {
                      this.$emit("invitationSent");
                    }
                  }
                ]
              });
            });
          this.$emit("sendInvitation");
        }
      }
    },
    resetFields() {
      this.prescription.attach_journal.first_name = "";
      this.prescription.mobile_number = "";
      this.prescription.email = "";
      // this.showSuccess = false;
    },
    getBrand(brandId) {
      this.$store.dispatch("share/getBrand", { brandId: brandId }).then(res => {
        this.brandInfo = res;
      });
    },
    setComputedDuration: _.debounce(function() {
      // this.clearEmail();
      this.validateNum();
    }, 800)
  },
  computed: {
    ...mapGetters("share", ["isGroupInvite", "groupInviteId"]),
    userInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    // brandInfo: {
    //   get() {
    //     return this.$store.state.user.brand
    //   }
    // },
    prescription: {
      get() {
        return this.$store.state.share.prescription;
      }
    },
    showSuccess: {
      get() {
        return this.$store.state.share.showSuccess;
      },
      set(v) {
        this.$store.commit("share/setShowSuccess", v);
      }
    }
  },
  components: {
    ModalHolder,
    TelInput
  }
};
</script>
